// import React from "react";
// import { Grid, Typography, Button, FormControl, TextField, InputLabel} from "@mui/material";
// import { AttachFile } from "@mui/icons-material";

// function CommitmentTab({
// 	ownerCommitment,
// 	setOwnerCommitment,
// 	consultantCommitment,
// 	setConsultantCommitment,
// 	contractorCommitment,
// 	setContractorCommitment,
// 	description,
// 	setDescription,
// }) {
// 	//const [ownerCommitmentFile, setOwnerCommitmentFile] = useState(null);
// 	//const [consultantCommitmentFile, setConsultantCommitmentFile] = useState(null);
// 	//const [contractorCommitmentFile, setContractorCommitmentFile] = useState(null);

// 	const handleFileChange = (e, commitmentType) => {
// 		switch (commitmentType) {
// 			case "owner":
// 				setOwnerCommitment(e.target.files[0]);
// 				break;
// 			case "consultant":
// 				setConsultantCommitment(e.target.files[0]);
// 				break;
// 			case "contractor":
// 				setContractorCommitment(e.target.files[0]);
// 				break;
// 			default:
// 				break;
// 		}
// 	};

// 	return (
// 		<Grid container spacing={2} paddingLeft={6} paddingRight={6}>
// 			<Grid item xs={12}>
// 				<Typography variant="subtitle1">Commitments (Signed Documents)</Typography>
// 			</Grid>
// 			<Grid item xs={12} md={4}>
// 				<FormControl fullWidth={true}>
// 					<Button variant="contained" component="label" startIcon={<AttachFile />}>
// 						Attach Owner Commitment
// 						<input
// 							type="file"
// 							accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
// 							onChange={(e) => handleFileChange(e, "owner")}
// 							style={{ display: "none" }}
// 						/>
// 					</Button>
// 				</FormControl>
// 			</Grid>
// 			<Grid item xs={12} md={4}>
// 				<FormControl fullWidth={true}>
// 					<Button variant="contained" component="label" startIcon={<AttachFile />}>
// 						<input
// 							type="file"
// 							accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
// 							onChange={(e) => handleFileChange(e, "consultant")}
// 							style={{ display: "none" }}
// 						/>
// 						Attach Consultant Commitment
// 					</Button>
// 				</FormControl>
// 			</Grid>
// 			<Grid item xs={12} md={4}>
// 				<FormControl fullWidth={true}>
// 					<InputLabel></InputLabel>
// 					<Button variant="contained" component="label" startIcon={<AttachFile />}>
// 						Attach Contractor Commitment
// 						<input
// 							type="file"
// 							accept=".pdf,.docx,.doc, .jpeg, .jpg,.png"
// 							onChange={(e) => handleFileChange(e, "contractor")}
// 							style={{ display: "none" }}
// 						/>
// 					</Button>
// 				</FormControl>
// 			</Grid>
// 			<Grid item xs={12}>
// 				<TextField
// 					label="Description"
// 					value={description}
// 					onChange={(e) => setDescription(e.target.value)}
// 					fullWidth={true}
// 					multiline
// 					rows={6}
// 				/>
// 			</Grid>
// 		</Grid>
// 	);
// }

// export default CommitmentTab;

//********************************* */
import React, { useState } from "react"; // MODIFIED: Added useState import
import { Grid, Typography, Button, FormControl, TextField, InputLabel} from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import { CheckCircle } from "@mui/icons-material"; // ADDED: Import CheckCircle icon

function CommitmentTab({
	ownerCommitment,
	setOwnerCommitment,
	consultantCommitment,
	setConsultantCommitment,
	contractorCommitment,
	setContractorCommitment,
	description,
	setDescription,
}) {
	// ADDED: New state to track which commitment files have been selected for icon display
	const [files, setFiles] = useState({
		owner: null,
		consultant: null,
		contractor: null
	});

	const handleFileChange = (e, commitmentType) => {
		const file = e.target.files[0]; // MODIFIED: Get the file first
		
		// KEPT: Original functionality - update the individual commitment states
		switch (commitmentType) {
			case "owner":
				setOwnerCommitment(file);
				break;
			case "consultant":
				setConsultantCommitment(file);
				break;
			case "contractor":
				setContractorCommitment(file);
				break;
			default:
				break;
		}

		// ADDED: Update files state for icon display when file is selected
		if (file) {
			setFiles(prev => ({
				...prev,
				[commitmentType]: file
			}));
		}
	};

	return (
		<Grid container spacing={2} paddingLeft={6} paddingRight={6}>
			<Grid item xs={12}>
				<Typography variant="subtitle1">Commitments (Signed Documents)</Typography>
			</Grid>
			<Grid item xs={12} md={4}>
  <FormControl fullWidth={true}>
    <Button 
      variant="contained" 
      component="label" 
      startIcon={files.owner ? <CheckCircle /> : <AttachFile />}
      sx={{ 
        backgroundColor: files.owner ? '#4caf50' : '#D0EBD0',
        '&:hover': {
          backgroundColor: files.owner ? '#45a049' : '#C0DBC0',
        },
        color: files.owner ? '#ffffff' : '#2e7d32',
        textTransform: 'none'
      }}
    >
      Attach Owner Commitment
      <input
        type="file"
        accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
        onChange={(e) => handleFileChange(e, "owner")}
        style={{ display: "none" }}
      />
    </Button>
  </FormControl>
</Grid>

<Grid item xs={12} md={4}>
  <FormControl fullWidth={true}>
    <Button 
      variant="contained" 
      component="label" 
      startIcon={files.consultant ? <CheckCircle /> : <AttachFile />}
      sx={{ 
        backgroundColor: files.consultant ? '#4caf50' : '#D0EBD0',
        '&:hover': {
          backgroundColor: files.consultant ? '#45a049' : '#C0DBC0',
        },
        color: files.consultant ? '#ffffff' : '#2e7d32',
        textTransform: 'none'
      }}
    >
      Attach Consultant Commitment
      <input
        type="file"
        accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
        onChange={(e) => handleFileChange(e, "consultant")}
        style={{ display: "none" }}
      />
    </Button>
  </FormControl>
</Grid>

<Grid item xs={12} md={4}>
  <FormControl fullWidth={true}>
    <Button 
      variant="contained" 
      component="label" 
      startIcon={files.contractor ? <CheckCircle /> : <AttachFile />}
      sx={{ 
        backgroundColor: files.contractor ? '#4caf50' : '#D0EBD0',
        '&:hover': {
          backgroundColor: files.contractor ? '#45a049' : '#C0DBC0',
        },
        color: files.contractor ? '#ffffff' : '#2e7d32',
        textTransform: 'none'
      }}
    >
      Attach Contractor Commitment
      <input
        type="file"
        accept=".pdf,.docx,.doc, .jpeg, .jpg,.png"
        onChange={(e) => handleFileChange(e, "contractor")}
        style={{ display: "none" }}
      />
    </Button>
  </FormControl>
</Grid>
			<Grid item xs={12}>
				<TextField
					label="Description"
					value={description}
					onChange={(e) => setDescription(e.target.value)}
					fullWidth={true}
					multiline
					rows={6}
				/>
			</Grid>
		</Grid>
	);
}

export default CommitmentTab;
//********************************** */